export default __webpack_public_path__ + "static/media/large-frame-bg1.957a9d48.svg";